export * from './doc-dir/getDocumentDirection';
